<template>
  <div class="course-package">
    <div
      class="item"
      v-for="(item, index) in config"
      :key="index"
      @click="goList(item.key)"
    >
      <p class="item-img"><img class="class" :src="item.icon" alt="" /></p>
      <p class="item-content">{{ item.value }}</p>
    </div>
    <div class="official_account" v-if='official'>
      <div class="official_account_content">
        <div class="official_account_box">
          <img class="wechat_pic" src="../../../static/images/official_bg.png" alt="">
          <p>关注微信公众号<b>“中公教育学习助手”</b><br/>绑定开课手机号，以获取更多服务</p>
          <input class="offcn_help" type="text" value='中公教育学习助手'>
          <span @click='close_mask'>复制公众号去关注</span>
        </div>
        <img @click='close_mask' class="close_btn" src="../../../static/images/close.png" alt="">
      </div>
    </div>
    <popup :type='1' @isopen="popup" class="popop_content" v-if='applets_flag&&ios'></popup>
    <popup :type='2' @isopen="popup" class="popop_content" v-if='applets_flag&&android'></popup>
    <div class="class_dialog" v-if="zujian_flag">
      <div class="dialog_box">
        <div class="dialog_message">手机浏览器暂不支持查看该课件<br/>你可在"{{ appname }}"进行查看</div>
        <p><span @click='cancel_flag'>取消</span>
          <span v-if='android' class="goapp"><a :href=scheme @click='search_flag'>打开APP</a></span>
          <span v-else-if='ios' class="goapp" @click='search_flag'>去APP查看</span>
          <!-- <wx-open-launch-app v-if='ua.match(/MicroMessenger/i) == "micromessenger"&&android'
            id="launch-btn" @error="handleErrorFn" @launch="handleLaunchFn" :appid=appid
          >
            <script type="text/wxtag-template">
              <style>.btn { color: #fff; font-size: 10px; text-align:center; line-height:23px}
			         </style>
               <div class="btn">去APP查看</div>
            </script>
          </wx-open-launch-app> -->
        </p>
      </div>
    </div>
    <arouse v-if="arshow" @arouse='receive'></arouse>
  </div>
</template>
<script>
import goapp from "../popup/goapp" //打开APP
import popup from "../popup/index" //小程序弹窗
import arouse from '../arouse/index.vue'
import { Toast } from "vant";

export default {
  data() {
    return {
      official: false,
      zujian_flag: false,
      ua: navigator.userAgent.toLowerCase(),
      android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
      ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      applets_flag: false,
      isapplets: false,
      appname: '',
      sf: '',
      arshow: false,
      isweixin: false,
      scheme:''
    }
  },
  props: ["config","strongtip","strongwxlist"],
  components: {
    Toast,
    popup,
    goapp,
    arouse
  },
  mounted() {
    // 小程序内
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        this.isapplets = true
      }
    })
    this.sf = this.$route.query.sf
    if (this.sf == 'zxkt') {
      this.appid = 'wx1062070e19e76b81'
      this.appname = '中公网校'
      this.scheme = 'zaixianketang://'
      this.open_url = 'https://www.eoffcn.com/wx_classonline/detail'
    } else if (this.sf == 'zgwx') {
      this.appid = 'wx1062070e19e76b81'
      this.appname = '中公网校'
      this.scheme = 'zaixianketang://'
      this.open_url = 'https://www.eoffcn.com/wx_classonline/detail'
    } else if (this.sf == 'sydw') {
      this.appid = 'wx4161c8d806017e0d'
      this.appname = '事业单位'
      this.scheme = 'shiyedanwei://'
      this.open_url = 'http://3min-class.offcn.com/videos/h5/download/institution/'
    } else if (this.sf == 'zgtk') {
      this.appname = '中公题库'
      this.scheme = 'zhonggongtiku://openapp'
      this.open_url = 'https://www.eoffcn.com/zg_questions/detail'
    } else if (this.sf == 'zgzsb') {
      this.appid = 'wx9487d9bc65834b47'
      this.appname = '中公专升本'
      this.scheme = 'zhonggongzhuanshengben://openapp'
      this.open_url = 'https://www.eoffcn.com/zg_zsb/detail'
    } else if (this.sf == 'zgyljy'){
      this.appid = 'wxc7238886c470203e'
      this.appname = '中公医疗教育'
      this.scheme = 'zhonggongyiliaojiaoyu://openapp'
      this.open_url = 'https://www.eoffcn.com/zg_yikao'
    } else if (this.sf == 'zgjsgc') {
      this.appname = '中公建设工程'
      this.open_url = 'https://www.zggcks.com/zg/2021jgapp/'
    } else if (this.sf == 'zgyouzhi') {
      this.appid = 'wx91652b0b55a2ca52'
      this.appname = '优职'
      this.scheme = 'zgyouzhi://openapp'
    } else {
      this.appid = 'wx4a8209bce2ce2a1d'
      this.appname = '中公教育'
      this.scheme = 'zhonggongjiaoyu://openapp'
    }
    //是否是微信浏览器
    if (/(micromessenger)/i.test(navigator.userAgent)) {
      //是否电脑微信或者微信开发者工具
      if(/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)){
        console.log('电脑微信或者微信开发者工具')
        this.isweixin = false;
      }else{
        //手机微信打开的浏览器
        console.log('手机微信')
        this.isweixin = true;
      }
    } else {
      console.log('其他浏览器')
      this.isweixin = false;
    }
  },
  methods: {
    receive (val) {
      this.arshow = val
    },
    goList(key) {
      if (key == 9) {
        this.official = true
      } else if(key == 99) {
        this.$router.push({
          path: "/commentReview",
          query: { order_id: this.$route.query.order_id, id: key }
        });
      } else if (key == 8) {
        this.$api.GETMAP({
          system_order_num: this.$route.query.order_id,
          "offcn-ticket": this.ticket,
          ticket_source: this.ticket_source,
          type: 8,
        }).then((res) => {
          if (res.data.list.length == 1 && res.data.list[0].list.length == 1) {
            location.href = 'https://qm.qq.com/cgi-bin/qm/qr?k='+ res.data.list[0].list[0].key +'&jump_from=webapi'
          } else {
            this.$router.push({
              path: "/commentReview",
              query: { order_id: this.$route.query.order_id, id: key }
            });
          }
        }).catch(() => {});
      } else {
        this.$router.push({
          path: "/commentReview",
          query: { order_id: this.$route.query.order_id, id: key }
        });
      }
    },
    popup() {
      this.applets_flag = false;
    },
    cancel_flag() {
      this.zujian_flag = false
    },
    openApp (src) {
      var d = new Date()
      var t0 = d.getTime()
      var delay = setInterval(function() {
        var d = new Date();
        var t1 = d.getTime();
        if( t1-t0<3000 && t1-t0>2000) {
          window.location.href = src;
        }
        if (t1 - t0 >= 3000) {
          clearInterval(delay);
        }
      },2000);
    },
    search_flag() {
      if(!this.isweixin){
        this.arshow = false;
        if (this.sf == 'zxkt' || this.sf == 'zgwx') {
          location.href = 'https://www.eoffcn.com/wx_classonline/detail/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.$route.query.order_id +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgtk') {
          location.href = 'https://www.eoffcn.com/zg_questions/detail/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.$route.query.order_id +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'sydw') {
          location.href = 'https://3min-class.offcn.mobi/institution/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.$route.query.order_id +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgzsb') {
          location.href = 'https://www.eoffcn.com/zg_zsb/detail/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.$route.query.order_id +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgyljy') {
          location.href = 'https://www.eoffcn.com/zg_yikao/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.$route.query.order_id +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgky') {
          location.href = 'https://www.eoffcn.com/zg_postgraduate/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.$route.query.order_id +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgjsgc') {
          this.openApp('https://www.zggcks.com/zg/2021jgapp/')
        } else if (this.sf == 'zgyouzhi'){
          if (this.android) {
            var SERVER_BASE_URL
            if (process.env.NODE_ENV=='production') {
              SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            } else {
              SERVER_BASE_URL = 'http://tiku.eoffcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            }
            this.openApp(SERVER_BASE_URL);
          } else if (this.ios) {
            location.href = 'https://www.eoffcn.com/zg_youzhi/detail?type=1&orderSn=' + this.$route.query.order_id + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
          }
        } else {
          if (this.android) {
            var SERVER_BASE_URL
            if (process.env.NODE_ENV=='production') {
              SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
            } else {
              SERVER_BASE_URL = 'http://tiku.t.eoffcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
            }
            this.openApp(SERVER_BASE_URL);
          } else if (this.ios) {
            location.href = 'https://www.eoffcn.com/zg_jiaoyu/detail?type=1&orderSn=' + this.$route.query.order_id + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
          }
        }
      }else{
        this.arshow = true;
      }
    },
    close_mask() {
      let help = $('.offcn_help')
      help.select(); // 选择对象
      document.execCommand("Copy");
      this.official = false
    },
    handleErrorFn(e) {
      this.arshow = true
      console.log(JSON.stringify(e), '跳转失败')
      Toast("当前手机未下载中公教育app");
      // this.download() // 这里跳转App下载页面
    },
    // 监听launch 函数
    handleLaunchFn(e) {
      // 跳转成功
      console.log(JSON.stringify(e), '跳转成功')
    },
    download(){
      //判断iPhone|iPad|iPod|iOS
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          window.location.href ="https://apps.apple.com/cn/app/%E4%B8%AD%E5%85%AC%E6%95%99%E8%82%B2/id735754930";
      } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
          window.location.href ="https://a.app.qq.com/o/simple.jsp?pkgname=com.offcn.android.offcn&channel=0002160650432d595942&fromcase=60001";
      } else {  // PC端
          window.location.href ="https://www.offcn.com/daohang/zgapp/#nub1";
      }
    },
    handleJudgeWechat() {
      const wechatInfo = window.navigator.userAgent.match(
        /MicroMessenger\/([\d\.]+)/i
      );
      if (!wechatInfo) return;
      let judgewechat = wechatInfo[1].split(".");
      let flag = false;
      if (judgewechat[0] >= 7) {
        if (judgewechat[1] >= 0) {
          if (judgewechat[2] >= 12) {
            this.wechatState = true;
            flag = true;
          }
        }
      }
      if (!flag) {
        Toast.fail('请升级当前微信版本');
        return false
      }
    },
  },
};
</script>
<style lang="less" scoped>
.course-package {
  width: 100%;
  padding: 20px 40px 0;
  display: flex;
  flex-grow: row;
  flex-wrap: wrap;
  .item {
    color: #4a4a4a;
    font-size: 24px;
    width: 25%;
    margin-bottom: 50px;
    text-align: center;
    .item-img {
      display: inline-block;
      img {
        display: inline-block;
        vertical-align: middle;
        width: 92px;
      }
    }
    .item-content{
      margin-top: 24px;
    }
  }
  .popop_content {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .class_dialog {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
    z-index: 2;
    .dialog_box {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 490px;
      line-height: 40px;
      border-radius: 18px;
      transform: translate(-50%, -50%);
      background: #fff;
      .dialog_message {
        text-align: center;
        padding: 30px 30px;
      }
      p {
        display: flex;
        border-top: 1px solid #e5e5e5;
        height: 70px;
        line-height: 70px;
        span {
          flex: 1;
          text-align: center;
        }
        .goapp {
          color: #e60012;
          border-left: 1px solid #e5e5e5;
          a {
            color: #e60012;
          }
        }
      }
    }
  }
  .official_account{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    background: rgba(0, 0, 0, .7);
    .official_account_content {
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .official_account_box{
      text-align: center;
      img{
        width: 600px;
      }
      p {
        position: absolute;
        left: 50%;
        bottom: 300px;
        width: 480px;
        font-size: 30px;
        transform: translate(-50%);
      }
      span{
        position: absolute;
        bottom: 150px;
        left: 50%;
        transform: translate(-50%);
        margin: 0 auto;
        width: 540px;
        height: 99px;
        font-size: 34px;
        line-height: 99px;
        border-radius: 8px;
        color: #ffffff;
        background: #94070a;
      }
    }
    .close_btn{
      display: block;
      width: 64px;
      height: 64px;
      margin: 0 auto;
      margin-top: 50px;
    }
    .offcn_help{
      position: absolute;
      opacity: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coursePackages/index.vue